// src/components/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when the path changes
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // No UI to render
}
